import { createPopper } from '@popperjs/core';
import bootstrap from 'bootstrap'

import stickyNavbar from './components/sticky-navbar';
import stuckNavbarMenuToggle from './components/stuck-navbar-menu-toggle';
import navDropdownA11y from './components/nav-dropdown-a11y';
import masonryGrid from './components/masonry-grid';
import passwordVisibilityToggle from './components/password-visibility-toggle';
import fileDropArea from './components/file-drop-area';
import formValidation from './components/form-validation';
// import smoothScroll from './components/smooth-scroll';
import scrollTopButton from './components/scroll-top-button';
import tooltip from './components/tooltip';
import popover from './components/popover';
import toast from './components/toast';
import disableDropdownAutohide from './components/disable-dropdown-autohide';
import carousel from './components/carousel';
import gallery from './components/gallery';
import productGallery from './components/product-gallery';
import imageZoom from './components/image-zoom';
import countdown from './components/countdown';
import charts from './components/charts';
import videoButton from './components/video-button';
import subscriptionForm from './components/subscription-form';
import rangeSlider from './components/range-slider';
import filterList from './components/filter-list';
import dataFilter from './components/data-filter';
import labelUpdate from './components/label-update';
import radioTab from './components/radio-tab';
import creditCard from './components/credit-card';
import masterCheckbox from './components/master-checkbox';

import Modal from 'bootstrap/js/dist/modal';
import BsCarousel from 'bootstrap/js/dist/carousel';
window.bootstrap = window.bootstrap || {};
window.bootstrap.Modal = Modal;
window.bootstrap.Carousel = BsCarousel;

import searchTools from './searchTools'

function initializeTracking() {
    document.addEventListener("click", function (e) {
        // Un contrôle de fermeture (croix, data-bs-dismiss) ne doit pas compter comme
        // un clic sur la zone trackée qui l'enveloppe (ex. croix de la bannière Nenustay)
        if (e.target.closest(".btn-close, [data-bs-dismiss]")) {
            return;
        }

        var element = e.target.closest("[track]");
        if (element && typeof _paq !== "undefined") {
            var trackData = element.getAttribute("track");
            if (trackData) {
                var [category, action, name, label] = trackData.split(",");
                if (category && action && name) {
                    var event = ['trackEvent', category.trim(), action.trim(), name.trim()];
                    if (label) {
                        event.push(label.trim());
                    }
                    _paq.push(event);
                }
            }
        }
    });
}

// Appeler la fonction pour attacher les écouteurs
initializeTracking();